<template>
  <div style="width: 100%;height: 100%;padding: 20px;box-sizing: border-box;background-color: white">
    <div style="height: 50px">
      <el-date-picker v-fixZoom v-model="sendTime" type="daterange" range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
      </el-date-picker>
      <el-button type="primary" @click="searchQuery">查询</el-button>
      <el-button type="primary" plain icon="el-icon-plus" @click="addPayment()">新增</el-button>
    </div>
    <div style="height: calc(100% - 100px)">
      <el-table v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="tableData" border style="width: 100%" highlight-current-row ref="singleTable">
        <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
        <el-table-column prop="person_name" label="服务对象" min-width="110" align="center"></el-table-column>
        <el-table-column prop="fee_amount" label="周期缴费金额" min-width="110" align="center"></el-table-column>
        <el-table-column prop="due_date" label="下次缴费时间" min-width="110" align="center"></el-table-column>
        <el-table-column label="缴费周期" min-width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.frequency === 30">月</span>
            <span v-if="scope.row.frequency === 90">季度</span>
            <span v-if="scope.row.frequency === 180">半年</span>
            <span v-if="scope.row.frequency === 360">一年</span>
          </template>
        </el-table-column>
        <el-table-column prop="balance" label="余额" min-width="110" align="center"></el-table-column>
        <el-table-column prop="last_paid_date" label="上次缴费时间" min-width="110" align="center"></el-table-column>
        <el-table-column align="center" label="操作" width="340">
          <template slot-scope="scope">
            <el-button type="primary" plain size="mini" @click="addPayment(scope.row)">缴费</el-button>
            <el-button type="warning" plain size="mini" @click="openRecords(scope.row)">缴费记录</el-button>
            <el-button type="success" plain size="mini" @click="editPayment(scope.row)">更新</el-button>
            <el-button type="danger" plain size="mini" @click="delPayment(scope.row)">终止</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="openShow" v-if="openShow"
               width="500px" :show-close="true" center class="all-open">
      <div class="title-top-alarm">
        <div><strong>{{titleShow}}</strong></div>
        <div class="line-title"></div>
      </div>
      <add-edit-payment v-model="openShow" :paymentObj="paymentObj" @getPayment="getTablePayment()"></add-edit-payment>
    </el-dialog>
    <el-dialog :visible.sync="openRecordsShow" v-if="openRecordsShow"
               width="900px" :show-close="true" :close-on-click-modal="true" center class="all-open">
      <div class="title-top-alarm">
        <div><strong>{{titleRecordsShow}}</strong></div>
        <div class="line-title"></div>
      </div>
      <payment-records v-model="openRecordsShow" :paymentObj="paymentObj"></payment-records>
    </el-dialog>
  </div>
</template>

<script>
import {deletepersoncarefeereminder, querypersoncarefeereminders} from '../../api/serviceMark'
import addEditPayment from './childComponents/addEditPayment.vue'
import paymentRecords from './childComponents/paymentRecords.vue'
export default {
  name: 'chargeReminder',
  components: {addEditPayment, paymentRecords},
  data () {
    return {
      sendTime: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [],
      openShow: false,
      titleShow: '',
      paymentObj: {
        isAdd: true,
        row: ''
      },
      openRecordsShow: false,
      titleRecordsShow: ''
    }
  },
  created () {
    // eslint-disable-next-line no-extend-native
    // Date.prototype.format = this.validate.format
    // let end = new Date().format('yyyy-MM-dd')
    // const start = this.commonType.GetDateStr(-30).format('yyyy-MM-dd')
    // this.sendTime = [start, end]
    console.log(888, this.sendTime)
    this.getTablePayment()
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.getTablePayment()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getTablePayment()
    },
    getTablePayment () {
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        from: this.sendTime[0] ? this.sendTime[0] + ' 00:00:00' : '',
        to: this.sendTime[1] ? this.sendTime[1] + ' 23:59:59' : '',
        pid: 0
      }
      this.loading = true
      querypersoncarefeereminders(params, data).then(res => {
        this.tableData = res.data.reminders
        this.totalCells = res.data.cnt
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    searchQuery () {
      this.currentPage = 1
      this.getTablePayment()
    },
    openRecords (row) {
      this.titleRecordsShow = '缴费记录'
      this.paymentObj.row = row
      this.openRecordsShow = true
    },
    addPayment (row) {
      this.titleShow = '新增缴费'
      this.paymentObj.isAdd = true
      this.paymentObj.row = ''
      if (row) {
        this.paymentObj.row = row
      }
      this.openShow = true
    },
    editPayment (row) {
      this.titleShow = '编辑缴费'
      this.paymentObj.isAdd = false
      this.paymentObj.row = row
      this.openShow = true
    },
    delPayment (row) {
      let name = row.person_name
      this.$confirm('此操作将永久终止【' + name + '】缴费, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          id: row.id
        }
        deletepersoncarefeereminder(data).then(res => {
          this.$notify({ title: '成功', message: '终止成功', type: 'success', duration: 2000 })
          if (this.tableData.length === 1 && this.currentPage > 1) {
            this.currentPage--
          }
          this.getTablePayment()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/chargeReminder.vue